import React, { ReactElement } from "react";
import styles from "./offices.module.scss";

export const Offices = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.header}>
        {props.badgeText && (
          <p className={styles.badgeText}>{props.badgeText}</p>
        )}
        <p className={styles.title}>{props.title}</p>
        <p className={styles.desc}>{props.desc}</p>
      </div>
      <div className={styles.visuals}>
        <img
          className={styles.map}
          src={props.imageUrl}
          alt="Kunduz"
          loading="lazy"
        />
        <div className={styles.locations}>
          {props.locations?.map((l, i) => (
            <div key={i} className={styles.location}>
              {l.flag && (
                <img
                  className={styles.flag}
                  src={l.flag}
                  alt={l.title}
                  loading="lazy"
                />
              )}
              <p className={styles.locationTitle}>{l.title}</p>
              <p className={styles.locationDesc}>{l.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

interface Props {
  badgeText?: string;
  badgeIcon?: React.ElementType;
  title: string;
  desc: string;
  imageUrl: string;
  locations?: {
    flag?: string;
    title: string;
    desc: string;
  }[];
}
